import { env } from "~/env";
import { TApiConfig } from "./fetchConfig";

type TFetchGetJson = {
  query?: string; // url 뒤에 붙이려는 문자열 API에서 생성해서 전달
  init?: Omit<RequestInit, "method">;
};

async function fetchGetJson(
  url: string,
  { query, init }: TFetchGetJson,
  config: TApiConfig,
) {
  const headers: Record<string, string> = {};
  let token;
  if (config.token) {
    token = config.token; // for ssr
  } else if (typeof window == "undefined") {
    token = null;
  } else {
    token = window.__APP_STATE__?.token; // for app
  }

  if (token) {
    headers["authorization"] = `Bearer ${token}`;
  }
  if (config.daoSubdomain) {
    headers["x-dao-sub-domain"] = config.daoSubdomain;
  }

  const requestInit: RequestInit = {
    method: "GET",
    referrerPolicy: "no-referrer-when-downgrade",
    credentials: "include",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    },
    cache: "no-store",
  };

  const API_URL = env.API_BASE_URL;

  return (
    fetch(toUrl(`${API_URL}${url}`, { query }), {
      ...requestInit,
      ...init,
    })
      // @TODO 핸들
      .then((res) => res.json())
  );
}

function toUrl(url: string, { query }: { query?: string }) {
  if (query) {
    return `${url}${query}`;
  }

  return url;
}

export { fetchGetJson };
